@use './tanstack-table' as *;

@layer design-system {
  .root {
    @include tanstack-table-root;
  }
}
